module.exports = __webpack_public_path__ + "img/Quility_MP_Live-Chat.8b3d468b.svg";